import i18next from 'i18next';

import utilsXLS from '@commons/utils/makeXLS';

const MARGIN_DECIMALS = 2;

const getColumnsSettings = () => [
  {
    propertyKey: 'name',
    name: i18next.t('EXTERNAL_CLIENTS.CREATION.CLONE_COLUMN_CLIENT'),
  },
  {
    propertyKey: 'externalReference',
    name: i18next.t('EXTERNAL_CLIENTS.CREATION.CLONE_COLUMN_EXTERNAL_REFERENCE'),
  },
  {
    propertyKey: 'stores',
    name: i18next.t('EXTERNAL_CLIENTS.CREATION.CLONE_COLUMN_STORES'),
    transform: (stores) => (stores ?? []).map(({ name }) => name).join(', '),
  },
  {
    propertyKey: 'priceWithTaxes',
    name: i18next.t('GENERAL.PRICE_TTC'),
    type: 'currency',
  },
  {
    propertyKey: 'margin',
    name: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_MARGIN_COLUMN'),
    type: 'percentage',
    decimals: MARGIN_DECIMALS,
  },
];

/**
 * Client-side XLSX generation of the external clients having the product in their catalog.
 *
 * @param {Object[]} externalClients - The external clients to write in the file
 * @param {Object} currency          - The client currency, used to format the price column
 *
 * @returns {void}
 */
export const exportProductExternalClients = (externalClients, currency) => {
  const sheet = utilsXLS.generateDefaultSheet(
    i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_TAB'),
    getColumnsSettings(),
    externalClients,
    currency,
  );

  utilsXLS.makeXLS(i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_EXPORT_FILENAME'), [sheet]);
};

export default { exportProductExternalClients };
